import script from "./DataFix.vue?vue&type=script&setup=true&lang=js"
export * from "./DataFix.vue?vue&type=script&setup=true&lang=js"

import "./DataFix.vue?vue&type=style&index=0&id=bf83df58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf83df58"]])

export default __exports__